module.exports = __webpack_public_path__ + "kz.126d85fd6ddfd7050a46.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/kz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/kz.svg
// module chunks = styles